import { render, staticRenderFns } from "./Winkelwagen.vue?vue&type=template&id=4bbf6274&scoped=true&"
import script from "./Winkelwagen.vue?vue&type=script&lang=js&"
export * from "./Winkelwagen.vue?vue&type=script&lang=js&"
import style0 from "./Winkelwagen.vue?vue&type=style&index=0&id=4bbf6274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf6274",
  null
  
)

export default component.exports